import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const TitleContainer = styled.div(
    ({ theme }) => css`
        padding: ${theme.spacing.xxSmall} ${theme.spacing.medium} ${theme.spacing.xxSmall};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.spacing.small} ${theme.spacing.large} ${theme.spacing.xxSmall};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.small} 0 ${theme.spacing.xSmall};
        }
    `,
)

export const Section = styled.section(
    () => css`
        width: inherit;
    `,
)

export const Title = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.125rem;
        font-weight: ${theme.typography.font.weight.bold};
        line-height: 1.425rem;
        color: #282828;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.xLarge};
            line-height: 2.5rem;
        }
    `,
)

export const SkeletonRow = styled.div`
    display: flex;
    gap: 0.75rem;
    overflow: hidden;
    padding: 0 ${({ theme }) => theme.spacing.medium};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 ${({ theme }) => theme.spacing.large};
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0;
    }

    > * {
        flex: 1;
        min-width: 0;
    }
`

export const SlideInner = styled.div`
    height: 100%;
    box-sizing: border-box;
`
